import './styles/app.css';

import React, { Suspense, lazy } from "react";
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from '@/redux/store';
import { ThemeProvider } from "@material-tailwind/react";
import { MaterialTailwindControllerProvider } from "@/context";

const EcosystemOs = lazy(() => import('./apps/EcosystemOs'));

export default function RootApp() {
    return (
        <React.StrictMode>
            <BrowserRouter>
                <Provider store={store}>
                    <ThemeProvider>
                        <MaterialTailwindControllerProvider>
                            {/* <Suspense fallback={<PageLoader />}> */}
                            <EcosystemOs />
                            {/* </Suspense> */}
                        </MaterialTailwindControllerProvider>
                    </ThemeProvider>
                </Provider>
            </BrowserRouter>

        </React.StrictMode >
    );
}
